import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    Input,
    Button,
    Typography,
    Alert,
    Row,
    Col,
    Card,
    Divider,
    // Space,
} from "antd";
import {
    LoginOutlined,
    // SafetyCertificateOutlined,
    // CustomerServiceOutlined,
} from "@ant-design/icons";

import { isIosStandalone } from "../../utils/platform"
import {
    authenticateUser,
    forgotPassword,
} from "../../redux/actions/salon-account/authenticate";
import ForgotPassword from "../ForgotPassword/ForgotPassword";

const { Title, Text, Link } = Typography;

const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

class Login extends Component {
    state = { forgotPassword: false };

    userChooseForgotPassword = () => {
        this.setState((prev) => ({ forgotPassword: !prev.forgotPassword }));
    };

    render() {
        const { forgotPassword } = this.state;
        const { loading, error, component, message } = this.props;

        const onFinish = (values) => this.props.authenticateUser(values);
        const onForgotPassword = (values) => this.props.forgotPassword(values);

        const year = new Date().getFullYear();

        return (
            <div className="dash-login-page">
                <Row justify="center" align="middle" className="dash-login-row">
                    <Col xs={22} sm={20} md={22} lg={18} xl={16} xxl={14}>
                        <Row gutter={[24, 24]} align="middle">
                            {/* Left brand panel (hidden on small screens) */}
                            {/* <Col xs={0} md={12}>
                                <div className="dash-login-brand">
                                    <h1 className="dash-logo">Dash Booking</h1>
                                    <Title level={2} className="dash-login-brand-title">
                                        Dash Booking Partners
                                    </Title>
                                    <Text className="dash-login-brand-subtitle">
                                        Manage appointments, staff, services, and sales — all in one place.
                                    </Text>

                                    <div className="dash-login-brand-bullets">
                                        <Space direction="vertical" size={10}>
                                            <Text>
                                                <SafetyCertificateOutlined /> Secure partner access
                                            </Text>
                                            <Text>
                                                <CustomerServiceOutlined /> Support when you need it
                                            </Text>
                                        </Space>
                                    </div>

                                    <div className="dash-login-brand-footer">
                                        <Text type="secondary">
                                            Tip: bookmark this page for faster access.
                                        </Text>
                                    </div>
                                </div>
                            </Col> */}

                            {/* Right login card */}
                            <Col xs={24} md={12}>
                                <Card className="dash-login-card" bordered={false}>
                                    <div className="dash-login-card-header">
                                        <h1 className="dash-logo">Dash Booking</h1>
                                        <Title level={3} style={{ marginBottom: 0 }}>
                                            Partner Portal
                                        </Title>
                                        <Text type="secondary">{!forgotPassword ? "Sign in to continue" : "Reset your password"}</Text>
                                    </div>

                                    <Divider />

                                    {!forgotPassword ? (
                                        <Form
                                            {...layout}
                                            layout="vertical"
                                            onFinish={onFinish}
                                            size="large"
                                            className="dash-login-form"
                                        >
                                            <Form.Item
                                                label="Email"
                                                name="email"
                                                rules={[
                                                    { required: true, type: "email", message: "Enter a valid email." },
                                                ]}
                                            >
                                                <Input placeholder="name@company.com" autoComplete="username" />
                                            </Form.Item>

                                            <Form.Item
                                                label="Password"
                                                name="password"
                                                rules={[{ required: true, message: "Enter your password." }]}
                                            >
                                                <Input.Password
                                                    placeholder="••••••••"
                                                    autoComplete="current-password"
                                                />
                                            </Form.Item>

                                            {error && (
                                                <Alert
                                                    message="Login failed"
                                                    description={error}
                                                    type="error"
                                                    showIcon
                                                    style={{ marginBottom: 16 }}
                                                />
                                            )}

                                            <div className="dash-login-actions">
                                                <Link style={{ color: "#0097b2" }} onClick={this.userChooseForgotPassword}>
                                                    Forgot your password?
                                                </Link>


                                            </div>
                                            <Button
                                                type="primary"
                                                icon={<LoginOutlined />}
                                                htmlType="submit"

                                                loading={loading}
                                                className="dash-login-button"
                                            >
                                                Login
                                            </Button>


                                            <Text type="secondary" className="dash-login-note">
                                                Having trouble? Contact your Dash Booking account manager for assistance.
                                            </Text>
                                            {isIosStandalone() && <Text type="secondary" >Stand Alone App</Text>}
                                        </Form>
                                    ) : (
                                        <ForgotPassword
                                            loading={loading}
                                            component={component}
                                            message={message}
                                            userChooseForgotPassword={this.userChooseForgotPassword}
                                            onForgotPassword={onForgotPassword}
                                        />
                                    )}

                                    <Divider />

                                    <div className="dash-login-footer">
                                        <Text type="secondary">{year} © Dash Booking Inc.</Text>
                                        <div className="dash-login-footer-links">
                                            <a
                                                href="https://www.dashbooking.com/business/partners-terms-and-conditions"
                                                rel="noreferrer"
                                                target="_blank"
                                            >
                                                Terms
                                            </a>
                                            <a
                                                href="https://www.dashbooking.com/privacy-policy"
                                                rel="noreferrer"
                                                target="_blank"
                                            >
                                                Privacy
                                            </a>
                                        </div>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.authenticate.loading,
    error: state.authenticate.error,
    message: state.authenticate.message,
    component: state.authenticate.component,
});

const mapDispatchToProps = (dispatch) => ({
    authenticateUser: (user) => dispatch(authenticateUser(user)),
    forgotPassword: (email) => dispatch(forgotPassword(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);